export default __webpack_public_path__ + "static/media/filters.d1c03ce9.svg";